import React from 'react';
import MenuItem from '../atom/menuItem';
class Menu extends React.Component {
    constructor(props) {
        super(props);
    }
    static index = 0;
    render() {
        let names = [];
        let urls = [];
        for (const name of this.props.names) {
            names.push(name);
        }
        for (const url of this.props.urls) {
            urls.push(url);
        }
        let items = [];
        for (let i = 0; i < names.length; i++) {
            items.push(React.createElement(MenuItem, { key: `menu-${Menu.index++}`, urlLink: urls[i], nameLink: names[i] }));
        }
        return (React.createElement("nav", { className: "row" },
            React.createElement("div", { className: "col-sm-12 navigation" },
                React.createElement("div", { className: "row" }, items))));
    }
}
export default Menu;
